import React,{Component} from 'react'
import { getCookie, stat, createUrl } from '../../common/utils'
import { ONECLOUD_API_HOST } from '../../common/consts'
import { jumpToLogin } from '../../components/SaleComponents'

const ACT_NOT_BEGIN = 0;
const ACT_ING = 1;
const ACT_END = 2;

export default class PSaleBook extends React.Component {
    constructor(props) {
        super(props);                      
        
        this.state = {
            status: ACT_ING,
            lock: false,                           
        };                             
    }    

    componentDidMount() {        
        this.loadConfig();
    }    

    loadConfig() {                   
        $.ajax({
            type: "post",           
            url: `${ONECLOUD_API_HOST}/presale/getconfig?t=${Date.now()}`,
            dataType: "json",
            crossDomain: true,
            xhrFields: { withCredentials: true },            
            cache: false,
            //ifModified: true,
            success: res => {                           
                if (res.iRet === 0) {
                    this.setState({
                        status: res.data.status
                    })
                }
            }
        });    
    }     
       
    isActIng() {
        const status = this.state.status;
        return status === ACT_ING ? true : false;
    }

    checkLogin() {  
       const depositUrl = createUrl('html/purchase', {type:'deposit'})
       stat('join', 'presale');
       $.ajax({
            type: "post",           
            url: `${ONECLOUD_API_HOST}/user/checklogin`,      
            dataType: "json",
            crossDomain: true,
            xhrFields: { withCredentials: true },            
            cache: false,
            ifModified: true,
            success: res => {
                const code = +res.iRet;
                let url;
                if (code === 0) {                    
                    location.href = depositUrl;
                } else {
                    location.href = `${createUrl('html/login')}?jumpurl=${encodeURIComponent(depositUrl)}`;
                }                
            },
            error: () => {
                location.href = depositUrl;
            }
        });            
    } 
         
   
    render() {                 
        const status = this.state.status;
        const btnCls = {
            '1': 'btn-activity btn-a-ban',
            '2': 'btn-activity',
            'gray': 'btn-a-disable'
        };        
        let btn1 = null, btn2 = null, btnTip = null;     

        if (status === ACT_ING) {           
            btn1 = <Btn className={btnCls['1']} onClick={() => this.checkLogin()} />;
            btn2 = <Btn className={btnCls['2']} onClick={() => this.checkLogin()} />;                
        } else {
            btn1 = <Btn className={`${btnCls['1']} ${btnCls.gray}`} isActIng={false} />;
            btn2 = <Btn className={`${btnCls['2']} ${btnCls.gray}`} isActIng={false} />;
            btnTip = <p className="a-ban-txt">预售活动已结束</p>;
        }      

        return (           
            <div>               
                {btn1}
                {btnTip}
                <div className="a-unit a-unit-ban">
                    <ul className="a-infolist">
                        <li className="a-infolist-1">
                            <img src="//static.onethingcloud.com/images/presell/left_pic.png" srcSet="//static.onethingcloud.com/images/presell/left_pic.png, //wk-sic.content.xunlei.com/images/presell/left_pic_m.png 750w" alt="" />
                            <div className="a-infolist-txt">
                                <h3>提前预售 &yen;399</h3>
                                <p>不预约、不抢购</p>
                            </div>
                        </li>
                        <li className="a-infolist-2">
                            <img src="//static.onethingcloud.com/images/presell/right_pic1.png" srcSet="//static.onethingcloud.com/images/presell/right_pic1.png, //wk-sic.content.xunlei.com/images/presell/right_pic1_m.png 750w" alt="" />
                            <div className="a-infolist-txt">
                                <h3>每位玩客限购1台</h3>
                                <p>让每位玩客都能参与中国区块链共享计算建设</p>
                                <em>（已在官网成功购买的用户无法参与本次预售活动）</em>
                            </div>
                        </li>
                        <li className="a-infolist-3">
                            <img src="//static.onethingcloud.com/images/presell/right_pic2.png" srcSet="//static.onethingcloud.com/images/presell/right_pic2.png, //wk-sic.content.xunlei.com/images/presell/right_pic2_m.png 750w" alt="" />
                            <div className="a-infolist-txt">
                                <h3>先选收货时间再付款</h3>
                                <p>早下单、早收货，最早1-2周发货</p>
                            </div>
                        </li>
                    </ul>
                </div>

                <div className="a-unit a-unit-rule">
                    <h3>预售活动规则</h3>
                    <ul className="a-rule-list">
                        <li>
                            <h4>预售活动期间</h4>
                            <p>12月13日-12月19日；</p>
                        </li>
                        <li>
                            <h4>预售开放时间</h4>
                            <p>12月13日-19日 每天10:00-18:00；</p>
                        </li>
                        <li>
                            <h4>预售商品</h4>
                            <p>玩客云，颜色为科技蓝、曜石黑、爱马仕橙；</p>
                        </li>
                        <li>
                            <h4>预售价格</h4>
                            <p>399元全款预售；</p>
                        </li>
                        <li>
                            <h4>预售</h4>
                            <p>是指您无需预约玩客云，选定发货时间后提前全款支付，以您支付成功系统告知发货时间为准，我们将按承诺的时间陆续为您安排发货；</p>
                        </li>
                        <li>
                            <h4>限购数量</h4>
                            <p><em>为充分保障用户权益，每个用户仅限购买1台玩客云，重复购买无效，已经成功在玩客云官网购买过玩客云的用户将无法参与本次预售活动；</em></p>
                        </li>
                        <li>
                            <h4>发货时间</h4>
                            <p><em>预售商品的发货时间，在您选定发货时间档内按付款的先后顺序陆续安排发出，网心科技保留提前发货的权利，</em>为了保证良好的用户体验，我们会在每月设置可发货的时间档位供用户选择；</p>
                        </li>
                        <li>
                            <h4>提交订单</h4>
                            <p>请正确填写收货信息，选取配送方式并确认所选商品颜色、价格信息，请尽快提交订单，订单一旦提交将不可取消；</p>
                        </li>
                        <li>
                            <h4>支付时效</h4>
                            <p><em>请留意您的订单支付时效，订单生成后即进入15分钟支付倒计时，</em>没有在支付时效内成功支付的订单，系统将视为您自动放弃并取消订单，您所占的发货时间名额也将被重新释放，已支付成功的订单视为本次预售下单成功；</p>
                        </li>
                        <li>
                            <h4>有关支付</h4>
                            <p>每位用户可以下单2次，仅可成功购买1次。您在订单生成后实际付款前超过2次超时未支付订单，将失去继续参与本次预售活动的资格，用户完成支付的时间以第三方支付或银行提供给网心的支付流水时间为准；</p>
                        </li>
                        <li>
                            <h4>预售商品支付价格</h4>
                            <p>以您支付成功时的价格为准，如预售商品发生调价，已支付订单将不受影响；</p>
                        </li>
                        <li>
                            <h4>预售订单快递</h4>
                            <p>预售订单不支持自提，我们默认申通快递，如选顺丰快递，需额外支付18元快递费用；</p>
                        </li>
                        <li>
                            <h4>淘宝众筹优惠券</h4>
                            <p>本次预售活动支持淘宝众筹期间购买的优惠券抵扣，请在优惠券有效期前完成使用，优惠券每个用户只能使用1张，不可叠加，一经使用立即作废，如使用优惠券后申请取消订单，退款时以实际支付金额为准；</p>
                        </li>
                        <li>
                            <h4>预售订单退款</h4>
                            <p>预售订单在预售活动结束后至发货日的前一天中午12:00之前，用户可通过我的订单自动申请售后取消预售订单，客服在收到您的申请后，将于3-5个工作日内为您办理退款操作，预售订单发货后，退换货流程同正常订单一致；</p>
                        </li>
                        <li>
                            <h4>订单地址不可修改</h4>
                            <p>为打击黄牛，收货信息将不可变更，请仔细确认您的收货信息，付款成功后将不可更改；</p>
                        </li>
                        <li>
                            <h4>防范黄牛</h4>
                            <p>为保护广大用户的权益，打击黄牛高价倒卖，网心将保留取消恶意订单并给予退款的权利，一旦发现用户存在恶意刷单、一人多单、超时支付等违规行为，网心有权立即取消用户的订单并给予退款，且该用户失去继续参与本次预售活动的资格。网心有权依据本协议约定内容基于独立自主判断认定用户是否存在恶意刷单、一人多单、超时支付等违规行为，如用户对网心取消订单存有异议的，应当自其订单被取消起24小时内与网心联系，超过24小时的，视为用户不存有任何异议。</p>
                        </li>
                        <li>
                            <h4>温馨提示</h4>
                            <p>1、玩客云官方购买渠道：玩客云PC版官网、移动版官网；</p>
                            <p>2、为确保您在更早的时间拿到商品，请在开售前校准您的电脑或手机时间；</p>
                            <p>3、如有任何疑问请拨打400-109-8880还可访问服务页<a href="http://wpa.qq.com/msgrd?v=3&uin=212454816&site=qq&menu=yes" target="_blank">联系QQ在线客服</a>，服务时间 09:00-21:00。</p>
                        </li>
                    </ul>				
                    {btn2}
                </div>                
            </div>          
        )
    }
}

const Btn = ({ isActIng, className, onClick }) => (    
    isActIng
        ? <a href="javascript:;" className={className} onClick={onClick}>参与预售</a>
        : <a href="javascript:;" className={className}>参与预售</a>    
);
Btn.defaultProps = {
    isActIng: true
};


// WEBPACK FOOTER //
// ./js/src/pages/PSaleBook/PSaleBook.js